import React from "react";
import { Form } from "react-bootstrap";
import SubmitButton from "../buttons/SubmitButton";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const LeadsTableFilter = (props) => {
  const { t } = useTranslation();
  const [searchKey, setSearchKey] = useState("");

  const handleChange = (e) => {
    const { value } = e.target;
    setSearchKey(value);
  };
  const handleSearch = () => {
    props.setCurrentPage(1);
    props.setIsFetchable(true);
    props.setSearchKey(searchKey);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      // If Enter key is pressed, trigger the search
      handleSearch();
    }
  };

  const resetHandler = () => {
    setSearchKey("");
    props.setCurrentPage(1);
    props.setIsFetchable(true);
    props.setSearchKey("");
  };

  return (
    <>
      <div className="filter_Section">
        <div className="row justify-content-end">
          <div className="col-md-4">
            <div className="right_search_div d-flex gap-1 nav-bar-flex">
              <Form.Group>
                <Form.Control
                  id="Search"
                  type="text"
                  placeholder={t("searchByNameOrMail")}
                  onChange={(e) => handleChange(e)}
                  onKeyPress={(e) => handleKeyPress(e)}
                  value={searchKey}
                  required
                />
              </Form.Group>
              <SubmitButton
                className="btn btn-primary"
                text="search"
                click={handleSearch}
              />
              <SubmitButton
                isSubmitting=""
                text="reset"
                className="btn btn-secondary"
                click={resetHandler}
                id="resetButton"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadsTableFilter;
